export enum ChatRoomType {
  PurchaseRequest = 'PurchaseRequest',
  Rfx = 'Rfx',
  CommercialDocument = 'CommercialDocument',
  Group = 'Group'
}
